import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import { useAppDispatch, useAppSelector } from "../../store/store";
import "../../css/interviews.css";
import InterviewListingItem from "../../components/interview/InterviewListingItem";
import { useGetInterviewsListingMutation } from "../../store/appSlice";
import { InterviewType } from "../../interfaces/user";
import { setInterviews } from "../../reducers/userReducer";
import { checkIfDateIsGreaterThanToday } from "../../functions/commons";
import { isEmpty } from "lodash";
import NoInterviews from "../../assets/images/no-interviews.svg";
import ButtonToggler from "../../components/ButtonsToggler";

function InterviewListing() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user, interviews } = useAppSelector((state) => state["user"]);
  const [interviewListing, setInterviewsListing] = useState<InterviewType[]>(
    []
  );
  const [tabSelected, setTabSelected] = useState<Number>(1);
  const [getInterviewsListing] = useGetInterviewsListingMutation();

  useEffect(() => {
    getInterviewsListing(user?.id)
      .unwrap()
      .then((interviews: InterviewType) => {
        console.log({ interviews });
        dispatch(setInterviews(interviews));
      });
  }, []);

  useEffect(() => {
    let filteredList = [];
    if (!isEmpty(interviews)) {
      if (tabSelected === 1) {
        filteredList = interviews.filter(
          (item) => checkIfDateIsGreaterThanToday(item.date) && item
        );
      } else {
        filteredList = interviews.filter(
          (item) => !checkIfDateIsGreaterThanToday(item.date) && item
        );
      }
    }

    setInterviewsListing(filteredList);
  }, [tabSelected, interviews]);

  return (
    <div className="interview__container">
      <Navbar />
      <div className="interview__content" style={{ marginTop: 100 }}>
        <div style={{ marginLeft: "3px" }}>
          <text className="interview_header_text">Interviews</text>
        </div>

        <div className="filter_buttons">
          <ButtonToggler
            onFirstBtnTap={() => setTabSelected(1)}
            onSecondBtnTap={() => setTabSelected(2)}
            firstBtnText={"Upcoming"}
            secondBtnText={"Previous"}
            isFirstBtnSelected={tabSelected === 1}
          />
        </div>

        {/* ////abc */}
        {!isEmpty(interviewListing) ? (
          <div className="interview_listing_container">
            <div className="interview_listing_headers">
              <text style={{ width: "22%" }}>Company Name</text>
              <text style={{ width: "31%" }}>Applied For</text>
              <text
                style={{
                  width: "32%",
                }}
              >
                Scheduled at
              </text>
            </div>
            {
              interviewListing.map((item) => (
                <InterviewListingItem data={item} />
              ))
              // <InterviewListingItem />
            }
          </div>
        ) : (
          <div className="jie-main__internal-wrapper">
            <div className="empty_sec">
              <img src={NoInterviews} alt="" />
              <text>No Interviews Found</text>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default InterviewListing;
